import * as types from './../actionTypes';
import client from 'helpers/client';
import {
  FETCH_LIST_CODE_BASE,
  FETCH_LIST_CODE_BASE_DETAIL,
  FETCH_RELEASE_DETAIL,
  GET_TRANSACTION,
} from './../actionTypes';
import cognito from 'helpers/cognito';
import paths from 'redux/paths';


export const getCodebaseDetail = (params) => (dispatch) => {
  dispatch({ type: types.FETCH_LIST_CODE_BASE_DETAIL });
  return client
    .api('/code-base/get-code-base-detail', 'get', { params })
    .then(({ data: response }) => {
      dispatch({ type: types.FETCH_LIST_CODE_BASE_DETAIL_SUCCESS });
      return response;
    })
    .catch((err) => {
      dispatch({ type: types.FETCH_LIST_CODE_BASE_DETAIL_FAILED, reason: err });
      return null;
    });
};

export const getReleaseDetail = (params) => (dispatch) => {
  dispatch({ type: types.FETCH_RELEASE_DETAIL });
  return client
    .api('/code-base/get-release-detail', 'get', { params })
    .then(({ data: response }) => {
      dispatch({ type: types.FETCH_RELEASE_DETAIL_SUCCESS });
      return response;
    })
    .catch((err) => {
      dispatch({ type: types.FETCH_RELEASE_DETAIL_FAILED, reason: err });
      return null;
    });
};
export const fetchCodeBase = (params) => {
  return (dispatch) => {
    dispatch({ type: types.FETCH_LIST_CODE_BASE });

    client
      .api(`/code-base/get-list`, 'get', {
        params: params,
      })
      .then((res) => {
        dispatch({
          type: types.FETCH_LIST_CODE_BASE_SUCCESS,
          data: res.data.data,
          reason: 'Fetch code base success',
        });
      })
      .catch((err) =>
        dispatch({
          type: types.FETCH_LIST_CODE_BASE_FAIL,
          reason: err,
        }),
      );
  };
};


// export const postTransaction = (params) => (dispatch) => {
//   dispatch({ type: types.POST_NFT_TRANSACTION });
//   return client
//     .api('/nft/create-transaction', 'post', { params })
//     .then(({ data: response }) => {
//       dispatch({ type: types.POST_NFT_TRANSACTION_SUCCESS });
//       return response;
//     })
//     .catch((err) => {
//       dispatch({ type: types.POST_NFT_TRANSACTION_FAILED, reason: err });
//       return null;
//     });
// };

export const postTransaction = (params) => async (dispatch) => {
  try {
    console.log("params", params);
    dispatch({ type: types.POST_NFT_TRANSACTION });

    const res = await client.sendRequest({
      path: paths.POST_NFT_TRANSACTION,
      params,
      method: 'post',
      headers: await cognito.getHeaderAuthorization(),
    });

    const { status, data } = res;
    if (status !== 'OK') {
      throw new Error(res.error);
    }

    dispatch({ type: types.POST_NFT_TRANSACTION_SUCCESS });
    return res;
  } catch (err) {
    dispatch({
      type: types.POST_NFT_TRANSACTION_FAILED,
      error: err.message,
    });
    return err;
  }
};

export const getLicense = (params) => async (dispatch) => {
  try {
    console.log("params", params);
    dispatch({ type: types.GET_LICENSE });

    const res = await client.sendRequest({
      path: paths.GET_LICENSE,
      params,
      method: 'get',
      headers: await cognito.getHeaderAuthorization(),
    });

    const { status, data } = res;
    if (status !== 'OK') {
      throw new Error(res.error);
    }

    dispatch({ type: types.GET_LICENSE_SUCCESS });
    return res;
  } catch (err) {
    dispatch({
      type: types.GET_LICENSE_FAILED,
      error: err.message,
    });
    return err;
  }
};

export const getTransactionOfUser = (params) => async (dispatch) => {
  try {
    console.log("params", params);
    dispatch({ type: types.GET_TRANSACTION });

    const res = await client.sendRequest({
      path: paths.GET_TRANSACTION,
      params,
      method: 'get',
      headers: await cognito.getHeaderAuthorization(),
    });

    const { status, data } = res;
    if (status !== 'OK') {
      throw new Error(res.error);
    }

    dispatch({ type: types.GET_TRANSACTION_SUCCESS });
    return res;
  } catch (err) {
    dispatch({
      type: types.GET_LICENSE_FAILED,
      error: err.message,
    });
    return err;
  }
};

export const getLicenseByUser = (params) => async (dispatch) => {
  try {
    console.log("params", params);
    dispatch({ type: types.GET_LICENSE_BY_USER });

    const res = await client.sendRequest({
      path: paths.GET_LICENSE_BY_USER,
      params,
      method: 'get',
      headers: await cognito.getHeaderAuthorization(),
    });

    const { status, data } = res;
    if (status !== 'OK') {
      throw new Error(res.error);
    }

    dispatch({ type: types.GET_LICENSE_BY_USER_SUCCESS });
    return res;
  } catch (err) {
    dispatch({
      type: types.GET_LICENSE_BY_USER_FAILED,
      error: err.message,
    });
    return err;
  }
};












